export default __webpack_public_path__ + "static/media/Montserrat-Light.34270926.ttf";